import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { createSelector } from '@ngrx/store';
import { getOfferItemListState } from '../item.reducer';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { EntityTypes } from '../../../entity/entity-types';
import { EntityState } from '../../../entity/entity.reducer';
import { denormalize } from 'normalizr';
import { Entities } from '../../../entity/entities';
import { OfferItem } from '../models/item';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';

const createState = (id: IdType) => createSelector(
  getOfferItemListState,
  (state: ByKey<ListState>) => state && state[id] && state[id]
);

const createStateById = (id: IdType) => createListStateIdsSelector(createState(id));

export const createOfferItemListData = (id: IdType) => createSelector(
  createStateById(id),
  createEntitiesSelector([
    EntityTypes.offerItem
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.offerItem]], entities) as OfferItem[]
);

export const createOfferItemListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createOfferItemListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createOfferItemListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createOfferItemListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createOfferItemListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
